import Swiper from 'swiper';
import { Mousewheel, FreeMode, Keyboard } from 'swiper/modules';
import 'swiper/swiper.css';
(window as any).isScrollLocked = false;
let swiperInstance;

let insideScrolly = false;
let readyToSwipe = true;

function setVariableToFalseForOneSecond() {
    readyToSwipe = false;

    setTimeout(() => {
        readyToSwipe = true;
    }, 500);
}
swiperInstance = new Swiper(".scrollytell", {
    speed: 600,
    touchReleaseOnEdges: true,
    modules: [Mousewheel, FreeMode, Keyboard],
    direction: "vertical",
    on: {
        slideChange: function (e) {
            const backgroundImages = document.querySelectorAll<HTMLElement>(".scrollytell__bg");
            backgroundImages.forEach((bgImg, index) => {
                const from = parseInt(bgImg.dataset.from ?? "");
                const to = parseInt(bgImg.dataset.to ?? "");
                if (e.activeIndex >= from && e.activeIndex <= to) {
                    bgImg.classList.add("scrollytell__bg--active");
                } else {
                    bgImg.classList.remove("scrollytell__bg--active");
                }
                const isLastElement = index === backgroundImages.length;

                if (!isLastElement) {
                    playActiveVideo();
                } //Enables videos and images to be in the same scrollytellcontainer by playing video on slide change
            });
        },
        reachEnd: function () {
            showFooter();
            scrolldown();
        },
        reachBeginning: function () {
            showHeader();
            scrollUp()
            scrollBackToElement('scrollytell-container');
            hideFooter();
        },
    },
});

function playActiveVideo() {
    const activeElements = document.querySelectorAll('.custom-video');
    activeElements.forEach(element => {
        if (element instanceof HTMLVideoElement) {
            if (element.paused || element.ended) {
                element.muted = true;
                element.play()
            }
        }
    });
}

function scrollBackToElement(elementId: string) {
    const element = document.getElementById(elementId);
    if (element) {
        const yOffset = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
            top: yOffset - 200
        });
    }
}

function scrollUp(): void {
    var firstElement = document.getElementById("feature-page-intro-container");
    if (firstElement){
        var height = firstElement.offsetHeight;
        var scrollHeight = height - 51;
        window.scrollBy(0, +scrollHeight); 
    }
}

function scrolldown(): void {
    window.scrollBy(0, +51);  //sends the user out of locked state at the end of scrollytell
}

function disableSwiper() {
    stopVideo();
    
    const bodyElement = document.body;

    if (bodyElement) {
        bodyElement.style.overflow = 'visible';
    }

    insideScrolly = false;
    (window as any).isScrollLocked = false;
    swiperInstance.enabled = false;
    const element = document.getElementById("header");
    if (element) {
        element.style.display = "block";
    }
}

function resumeSwiper() {
    const video = document.getElementById("bgImageScrolly") as HTMLVideoElement;
    if (video instanceof HTMLVideoElement) {
        playVideo();   
    }
    const bodyElement = document.body;

    if (bodyElement) {
        bodyElement.style.overflow = 'hidden';
    }

    insideScrolly = true;
    swiperInstance.enabled = true;
    const element = document.getElementById("header");
    if (element) {
        element.style.display = "none";
    }
    hideHeader();

}

function checkIfImageCentered() {
    function getCenterYCoordinate() {
        const image = document.getElementById('bgImageScrolly');
        if (!image) return null;
        const rect = image.getBoundingClientRect();
        const centerY = rect.top + rect.height / 2;
        return centerY;
    }

    const imageCenterY = getCenterYCoordinate();
    if (!imageCenterY) return;

    const viewportHeight = window.innerHeight;
    const viewportCenterY = viewportHeight / 2;

    const difference = imageCenterY - viewportCenterY;
    const tolerance = 50;

    if (Math.abs(difference) <= tolerance) {
        resumeSwiper();
        window.scrollBy(0, difference);
    } else {
        disableSwiper();
    }
}

function hideFooter(): void {
    const scrollytell = document.getElementById('scrollytell-container');

    if (scrollytell) {
        let nextElement = scrollytell.nextElementSibling as HTMLElement;
        scrollytell.style.marginBottom = "0px";
        while (nextElement) {
            nextElement.style.display = 'none';
            nextElement = nextElement.nextElementSibling as HTMLElement;
        }
    }

    const footer = document.getElementById('footer');
    if (footer) {
        footer.style.display = 'none';
    }
}

function showFooter(): void {
    const scrollytell = document.getElementById('scrollytell-container');

    if (scrollytell) {
        scrollytell.style.marginBottom = "96px";
        let nextElement = scrollytell.nextElementSibling as HTMLElement;

        while (nextElement) {
            nextElement.style.display = 'block';
            nextElement = nextElement.nextElementSibling as HTMLElement;
        }
    }

    const footer = document.getElementById('footer');
    if (footer) {
        footer.style.display = 'block';
    }
}

function hideHeader() {
    const header = document.getElementById('feature-page-intro-container');
    if (header) {
        header.style.display = 'none';
    }
    const scrollytell = document.getElementById('scrollytell-container');

    if (scrollytell) {
        let prevElement = scrollytell.previousElementSibling as HTMLElement;
        scrollytell.style.marginTop = "0px";
        while (prevElement) {
            prevElement.style.display = 'none';
            prevElement = prevElement.previousElementSibling as HTMLElement;
        }
    }
}

function showHeader() {
    const header = document.getElementById('feature-page-intro-container');
    if (header) {
        header.style.display = 'block';
    }
    const scrollytell = document.getElementById('scrollytell-container');
    if (scrollytell) {
        scrollytell.style.marginTop = "0px"; // Adjust the margin as needed
        let prevElement = scrollytell.previousElementSibling as HTMLElement;

        while (prevElement) {
            prevElement.style.display = 'block';
            prevElement = prevElement.previousElementSibling as HTMLElement;
        }
    }
}

function playVideo() {
    const video = document.getElementById("bgImageScrolly") as HTMLVideoElement;
    if (video) {
        video.muted = true;
        video.play();
    }
}

function stopVideo() {
    const videos = document.querySelectorAll(".custom-video") as NodeListOf<HTMLVideoElement>;
    if (videos.length > 0){
        videos.forEach(video => {
            if (video) {
                video.pause();
            }
        });
    }   
}

function removeTextWithoutTouchingChildren(element) {
    let child = element.firstChild;
    while (child) {
        // Store reference to next sibling since we may remove the current child
        let nextChild = child.nextSibling;

        // If the child node is a text node (nodeType === 3), remove it
        if (child.nodeType === 3) {
            element.removeChild(child);
        }
        // Move to the next child
        child = nextChild;
    }
}

window.onload = function () {
    const scrollytellElement = document.querySelector(".scrollytell");

    if (scrollytellElement) {
        disableSwiper();
        hideFooter();

        const bodyElement = document.querySelector('.FeatureArticlePage');
        if (bodyElement) {
            removeTextWithoutTouchingChildren(bodyElement); //Removing free text "header" to make sure that bg image covers 100% of the screen
        }
    }
};

type Direction = 'up' | 'down';
function changePage(direction: Direction) {
    if (!readyToSwipe) {
        return
    }

    setVariableToFalseForOneSecond();
    if (insideScrolly) {
        if (direction == "down") {
            swiperInstance.slideNext();
        } else if (direction === "up") {
            swiperInstance.slidePrev();
        }
    }
}


window.addEventListener('scroll', (event) => {
    const scrollytellElement = document.querySelector(".scrollytell");

    if (!scrollytellElement) {
        return;
    }
    checkIfImageCentered()

});
                                        
window.addEventListener('wheel', (event) => { //Wheel slide
    const scrollytellElement = document.querySelector(".scrollytell");

    if (!scrollytellElement) {
        return;
    }
    const swipeStrengthThreshold = 50;

    if (Math.abs(event.deltaY) > swipeStrengthThreshold) {
        const direction = event.deltaY > 0 ? 'down' : 'up';
        changePage(direction)
    }
});

window.addEventListener('keyup', (event) => { //Keyboard slide 
    const scrollytellElement = document.querySelector(".scrollytell") as HTMLElement;
    if (!scrollytellElement) {
        return;
    }
    if (!insideScrolly) {
        return
    }

    if (event.key === 'ArrowUp' || event.key === 'ArrowLeft' ||  event.shiftKey && event.key === 'Tab') {
        swiperInstance.slidePrev();
    } else if (event.key === 'ArrowDown' || event.key === 'ArrowRight' || event.key === 'Tab') {
        swiperInstance.slideNext();
    }   
}); 

window.addEventListener('keydown', (event) => {
    const scrollytellElement = document.querySelector(".scrollytell") as HTMLElement;
    if (!scrollytellElement) {
        return;
    }
    if (event.key === 'Tab') {
        event.preventDefault(); // Prevent the default tab behavior
    }
});